import { render, staticRenderFns } from "./Fases.vue?vue&type=template&id=6bb771d2&"
import script from "./Fases.vue?vue&type=script&lang=js&"
export * from "./Fases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports